import React, { useContext, useRef } from "react";
import Vehicle from "./Vehicle";
import AppContext from "../context";
import { useTranslation } from "react-i18next";
export default function OccupantView({ v, k }) {
	// console.log(v);
	const lc = (text) => {
		if (text) return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
		return "";
	};
	const guilty =
		v.contributing_factor1 &&
		v.contributing_factor1 !== "N" &&
		v.contributing_factor1 !== "NONE";

	const { setModal } = useContext(AppContext);
	const popover = useRef();
	const popover2 = useRef();
	const popover3 = useRef();
	const { t } = useTranslation();

	return (
		<div className="occupant">
			<div className="inner">
				{<Vehicle v={v} k={k} />}
				<div className="table-holder">
					<h2>
						{lc(v.vehicle_maker)}
						<span>
							{v.vehicle_model_year ? " - " + v.vehicle_model_year : ""}
							{v.vehicle_color ? ", " + lc(v.vehicle_color) : ""}
						</span>
					</h2>
					{guilty ? (
						<div className="at-fault">
							<img src="/assets/icon-at-fault.svg" />
						</div>
					) : null}
					<table>
						<thead>
							<tr>
								<th>{t("OCCUPANT")}</th>
								<th>{t("SAFETY_BELT")}</th>
								<th>{t("AIR_BAGS")}</th>
								<th>{t("DESCRIPTION")}</th>
							</tr>
						</thead>
						<tbody>
							{v.participants.map((p, k) => {
								let seatBeltClassColor = "green";
								if (p.seatbelt === "NONE") seatBeltClassColor = "red";
								if (!p.seatbelt || p.seatbelt === "UNKNOWN")
									seatBeltClassColor = "gray";

								let airbagClassColor = "red";
								if (p.airbag === "UNKNOWN" || p.airbag === "NOT DEPLOYED")
									airbagClassColor = "green";
								if (!p.airbag || p.airbag === "NOT APPLICABLE")
									airbagClassColor = "gray";

								let injuryClassColor = "orange";
								if (p.injury === "NOT INJURED") injuryClassColor = "blue";
								if (
									!p.injury ||
									p.injury === "UNKNOWN" ||
									p.injury === "NONE DETECTED"
								)
									injuryClassColor = "gray";

								return (
									<tr key={k}>
										<td>
											<div className={"circle " + injuryClassColor}>
												{k + 1}
											</div>
										</td>
										<td>
											<div className={"circle " + seatBeltClassColor}>
												<img src="/assets/icon-belt.svg" />
											</div>
										</td>
										<td>
											<div className={"circle " + airbagClassColor}>
												<img src="/assets/icon-airbag.svg" />
											</div>
										</td>
										<td>
											<strong>
												{p.type ? lc(p.type) : t("PERSON") + " " + (k + 1)}:{" "}
											</strong>
											{p.person_age
												? p.person_age + t("YEARS_OLD") + ", "
												: " "}
											{p.gender ? lc(p.gender) + ", " : " "}
											{lc(p.injury)}
											{p.seatbelt ? (
												<>
													<br />
													<strong>{t("SEATBELT")}: </strong>
													{lc(p.seatbelt)}
												</>
											) : null}
											{p.airbag ? (
												<>
													<br />
													<strong>{t("AIRBAGS")}: </strong>
													{lc(p.airbag)}
												</>
											) : null}
											<br />
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					<div className="buttons">
						<div>
							<div className="compensation-popover" ref={popover}>
								{t(
									"THE_DRIVER_OR_PASSENGER_OF_THIS_VEHICLE_MAY_BE_ENTITLED_TO_LEGAL_COMPENSATION"
								)}
							</div>
							<button
								onClick={() => setModal("carLead-" + k)}
								style={{
									opacity: guilty ? 0 : 1,
									pointerEvents: guilty ? "none" : "all"
									// width: 270
								}}
								onMouseOver={() => popover.current.classList.add("show")}
								onMouseOut={() => popover.current.classList.remove("show")}
								data-testid="but1"
							>
								<img src="/assets/icon-hammer-2.svg" /> {t("COMPENSATION")}
							</button>
						</div>
						<div>
							<div className="compensation-popover valuation" ref={popover2}>
								{t("RECEIVE_AN_OFFER_FROM_CARBRAIN_FOR_YOUR_DAMAGED_VEHICLE")}
							</div>

							<div className="compensation-popover valuation" ref={popover3}>
								{t(
									"THIS_VEHICLE_WAS_INVOLVED_IN_A_RECALL_THAT_COULD_HAVE_CONTRIBUTED_TO_YOUR_ACCIDENT"
								)}
							</div>

							{v.recallData?.length ? (
								<button
									className="white"
									onClick={() => setModal("recall-" + k)}
									onMouseOver={() => popover3.current.classList.add("show")}
									onMouseOut={() => popover3.current.classList.remove("show")}
									data-testid="but2"
									style={{ padding: "5px 30px" }}
								>
									<img src="/assets/nhtsa.png" height="43" />
									<img src="/assets/product-recall.jpg" height="43" />
								</button>
							) : (
								<button
									className="white"
									onClick={() => setModal("carBrain-" + k)}
									onMouseOver={() => popover2.current.classList.add("show")}
									onMouseOut={() => popover2.current.classList.remove("show")}
									data-testid="but2"
								>
									<img src="/assets/icon-tag.svg" style={{ opacity: 0.5 }} />{" "}
									{t("VALUATION_AFTER_ACCIDENT")}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
